<div class="dialog-content flex-col w-100 justify-stretch items-stretch">
	<h2 mat-dialog-title>{{title}}</h2>
	<mat-dialog-content>
		<div [innerHTML]="message"></div>
	</mat-dialog-content>
	<mat-dialog-actions>
		<div class="flex-row justify-center w-100 my-3">
			<button mat-flat-button class="w-50" color="primary" (click)="onConfirmClick()" tabindex="1" >{{confirmButtonText}}</button>
		</div>
	</mat-dialog-actions>
</div>

